export default "__VITE_ASSET__63ec9911__"